import { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Option } from "@/@types/generics/Option";
import { HealthTeam } from "@/@types/esus/HealthTeam";

import { HealthTeamsSelect } from "@/components/HealthTeamsSelect";
import { quarterOptions, QuartersSelect } from "@/components/QuartersSelect";
import { indicatorsEsfOptions, IndicatorsEsfSelect } from "@/components/IndicatorsEsfSelect";
import { getMonthOptionsFromQuarter, MonthsSelect } from "@/components/MonthsSelect";

type IndicatorsEsfFiltersProps = {
	selectedIndicator: number;
	setSelectedIndicator: (indicator: number) => void;
	selectedQuarter: string;
	setSelectedQuarter: (selectedQuarter: string) => void;
	selectedMonth: string;
	setSelectedMonth: (selectedMonth: string) => void;
	selectedIne?: string;
	setSelectedIne: (selectedHealthTeam?: string) => void;
	healthTeams: HealthTeam[];
	handleFilter: (selectedQuarter: string, selectedHealthTeam?: string) => void;
};

export function IndicatorsEsfFilters({
	selectedIndicator,
	setSelectedIndicator,
	selectedQuarter,
	setSelectedQuarter,
	selectedMonth,
	setSelectedMonth,
	selectedIne,
	setSelectedIne,
	healthTeams,
	handleFilter,
}: Readonly<IndicatorsEsfFiltersProps>) {
	const selectedIndicatorOption = indicatorsEsfOptions.find(
		(option) => option.value === Number(selectedIndicator)
	);
	const selectedQuarterOption = quarterOptions.find((option) => option.value === selectedQuarter);
	const selectedMonthOption = getMonthOptionsFromQuarter(selectedQuarter).find(
		(option) => option.value === selectedMonth
	);
	const selectedIneOption = healthTeams
		.map((healthTeam) => ({
			value: healthTeam.ine,
			label: `${healthTeam.name}-${healthTeam.ine}`,
		}))
		.find((option) => option.value === selectedIne);

	useEffect(() => {
		const monthOptions = getMonthOptionsFromQuarter(selectedQuarter);

		if (monthOptions.length > 0) {
			setSelectedMonth(monthOptions[0].value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedQuarter]);

	return (
		<Row className="bg-white">
			<Col className="mb-2" sm={12} md={6} lg={3} xl={3}>
				<IndicatorsEsfSelect
					value={selectedIndicatorOption}
					onChange={(newValue) =>
						setSelectedIndicator((newValue as Option<number>).value)
					}
				/>
			</Col>
			<Col className="mb-2" sm={6} md={3} lg={2} xl={2}>
				<QuartersSelect
					value={selectedQuarterOption}
					onChange={(newValue) => setSelectedQuarter((newValue as Option<string>).value)}
				/>
			</Col>
			<Col className="mb-2" sm={6} md={3} lg={2} xl={2}>
				<MonthsSelect
					quarter={selectedQuarter}
					value={selectedMonthOption}
					onChange={(newValue) => setSelectedMonth((newValue as Option<string>).value)}
				/>
			</Col>
			<Col className="mb-2" sm={12} md={6} lg={3} xl={3}>
				<HealthTeamsSelect
					healthTeams={healthTeams}
					value={selectedIneOption}
					onChange={(newValue) => setSelectedIne((newValue as Option<string>)?.value)}
				/>
			</Col>
			<Col className="mb-2 d-flex align-items-end" sm={3} md={3} lg={2} xl={2}>
				<Button onClick={() => handleFilter(selectedQuarter, selectedIne)}>
					Consultar
				</Button>
			</Col>
		</Row>
	);
}
